import React from "react";

const HairBeautyNearMeCustomer = () => {
  return (
    <div className="hairSalonNearMeCustomer">
      <h5>
        What Clients Say About SCENT: The Best Hair and Beauty Salon Near Me
      </h5>
      <p>
        Don’t just take our word for it! Here’s what our happy clients have to
        say about their experiences at SCENT:
      </p>
      <div className="hairSalonNearMeCustomerContent">
        <p>
          <span className="quote">“</span>I was searching for a hair and beauty
          salon near me that could handle both my hair and skincare needs. SCENT
          exceeded my expectations! The staff is incredibly professional, and
          the results were amazing.
          <span className="quote">”</span> - <span>Priya</span>
        </p>
        <p>
          <span className="quote">“</span>SCENT is by far the best hair and
          beauty salon near me. I’ve been coming here for years, and I’m always
          impressed with the level of service and the luxurious atmosphere.
          Highly recommend
          <span className="quote">”</span> - <span>Aditi </span>
        </p>
        <p>
          <span className="quote">“</span>The team at SCENT really knows how to
          make you feel special. From my hair treatment to my manicure,
          everything was perfect. If you’re looking for a hair and beauty salon
          near me, SCENT is the place to go
          <span className="quote">”</span> - <span> Simran</span>
        </p>
      </div>
    </div>
  );
};

export default HairBeautyNearMeCustomer;
